// extracted by mini-css-extract-plugin
export var fullHeightState = "_4n-7";
export var headerCell = "_4n-1";
export var loadingStateCell = "_4n-4";
export var rowWrapper = "_4n-3";
export var standaloneTable = "_4n-8";
export var standaloneTableWithBodyFill = "_4n-9";
export var stateCell = "_4n-5";
export var table = "_4n-0";
export var tableBodyFiller = "_4n-6";
export var white = "_4n-2";